import React from 'react';
import { Smile, Stethoscope, Shield, Activity, Skull, Baby, Star, PlusSquare } from 'lucide-react';
import { useDentoData } from '../context/DentoContext';

const getIcon = (iconName) => {
    switch (iconName) {
        case 'Stethoscope': return <Stethoscope className="w-8 h-8 text-black" />;
        case 'Shield': return <Shield className="w-8 h-8 text-black" />;
        case 'Activity': return <Activity className="w-8 h-8 text-black" />;
        case 'Skull': return <Skull className="w-8 h-8 text-black" />;
        case 'Baby': return <Baby className="w-8 h-8 text-black" />;
        case 'star': return <Star className="w-8 h-8 text-black" />;
        case 'medical': return <PlusSquare className="w-8 h-8 text-black" />;
        default: return <Smile className="w-8 h-8 text-black" />;
    }
};

export const SpecialitiesSection = () => {
    const { hospitalData } = useDentoData();

    return (
        <section id="services" className="py-16 md:py-24 bg-white">
            <div className="container mx-auto px-4 text-center font-body">
                <h2 className="text-2xl md:text-4xl font-extrabold text-black mb-4 font-heading tracking-tight">
                    Our Services
                </h2>
                <div className="w-16 h-1.5 bg-black mx-auto mb-6 rounded-full"></div>
                <p className="text-black/50 max-w-xl mx-auto text-base md:text-lg mb-12 md:mb-16">
                    Comprehensive dental care for you and your family
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 max-w-6xl mx-auto">
                    {hospitalData.services.map((service, index) => (
                        <div
                            key={index}
                            className="bg-gray-50 rounded-[32px] p-6 md:p-10 hover:shadow-2xl hover:shadow-gray-200 transition-all duration-500 group border border-gray-100 flex flex-col items-start text-left"
                        >
                            <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-8 shadow-sm group-hover:scale-110 transition-transform duration-500 border border-gray-100">
                                {getIcon(service.icon)}
                            </div>
                            <h3 className="text-2xl font-bold text-black mb-4 font-heading tracking-tight">
                                {service.name}
                            </h3>
                            <p className="text-black/60 leading-relaxed mb-8 flex-grow">
                                {service.description}
                            </p>
                            <div className="flex flex-wrap gap-2 mt-auto">
                                {(service.features || ["Dental Care"]).map((tag, idx) => (
                                    <span key={idx} className="bg-white px-3 py-1.5 rounded-full text-[10px] font-bold text-black border border-gray-200 tracking-wider uppercase">
                                        {tag}
                                    </span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
